module.exports = __webpack_public_path__ + "static/media/22791606_1629548480453670_7759342600821590369_o.a7e67764.jpg";